import React, { cloneElement, PropsWithChildren } from 'react';
import { Heading, Group, Skeleton, Box } from '@landr/maestro';

const HeadingItem: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Group.Item>
            <Heading
                as="h1"
                textStyle={{ base: 'title', md: 'headline-sm' }}
                mb="none"
            >
                {children}
            </Heading>
        </Group.Item>
    );
};

const AsteriskItem: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Group.Item width="md" height="44px" alignItems="center">
            <Box marginRight="xs" lineHeight="0">
                {children}
            </Box>
        </Group.Item>
    );
};

const TitleSkeleton = () => {
    return (
        <Skeleton
            minWidth="250px"
            width="40%"
            height={{ base: 'md', md: 'sm' }}
        />
    );
};

const Title = ({
    isLoading,
    title,
    icon,
}: {
    isLoading: boolean;
    title: string;
    icon?: JSX.Element;
}) => {
    if (isLoading) {
        return <TitleSkeleton />;
    }

    return (
        <Group alignItems="center" gap="none" maxWidth="768px" minHeight="md">
            {icon && <AsteriskItem>{cloneElement(icon)}</AsteriskItem>}
            <HeadingItem>{title}</HeadingItem>
        </Group>
    );
};

export default Title;
